export default "__VITE_ASSET__4df7a156__"